function Footer() {
  return (
    <footer className="footer mt-auto bg-white py-4 text-center font-inter text-defaultsize font-normal leading-normal text-[0.813] shadow-[0_0_0.4rem_rgba(0,0,0,0.1)] dark:bg-bodybg xl:ps-[15rem]">
      <div className="container">
        <span className="text-gray dark:text-defaulttextcolor/50">
          {' '}
          Copyright © <span id="year">2024</span>{' '}
          <a href="#" className="font-semibold text-defaulttextcolor dark:text-defaulttextcolor">
            Trees N Clouds Exchange, LLC
          </a>
          . Designed with <span className="bi bi-heart-fill text-danger"></span> by{' '}
          <a href="#">
            <span className="font-semibold text-primary underline">Trees N Clouds, Inc.</span>
          </a>{' '}
          All rights reserved
        </span>
      </div>
    </footer>
  );
}

export default Footer;
